// extracted by mini-css-extract-plugin
export default {"container":"DeviceLogs_container__-6udc","heading_label":"DeviceLogs_heading_label__-J9Bv","back":"DeviceLogs_back__CvclH","angle_icon":"DeviceLogs_angle_icon__MQKMn"};